import { HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { map, take } from 'rxjs/operators';

import { MediaAdapter } from '@modules/content-api/adapter/media.adapter';
import { TestRouteAdapter, TestRouteResponse } from '@modules/content-api/adapter/test-route.adapter';
import { ContentAPIService } from '@modules/content-api/content-api.service';
import { SectionType } from '@modules/section/enums/section-type.enum';

import { TestRoutePageModel } from './models/test-route-page.model';

const TEST_ROUTE_PAGE_PARAMS = new HttpParams().appendAll({
  include: 'test_routes,preview_map_small',
});

@Injectable({
  providedIn: 'root',
})
export class TestRoutePageService {
  private apiService = inject(ContentAPIService);
  private testRouteAdapter = inject(TestRouteAdapter);
  private mediaAdapter = inject(MediaAdapter);

  public getTestRoute(id: string) {
    return this.apiService.getResource('test_routes_sections', id, TEST_ROUTE_PAGE_PARAMS).pipe(
      take(1),
      map((data: any) => {
        try {
          return new TestRoutePageModel({
            id: data.id,
            headline: data.title,
            anchor: data.anchor_link,
            type: SectionType.TEST_ROUTE,
            latMax: data.max_lat,
            latMin: data.min_lat,
            lngMax: data.max_lng,
            lngMin: data.min_lng,
            latCenter: data.center_lat,
            lngCenter: data.center_lng,
            routes: data.test_routes.map((route: TestRouteResponse) => this.testRouteAdapter.parse(route)),
            consentBackgroundImgUrl: data.preview_map_small
              ? this.mediaAdapter.parseStaticImage(data.preview_map_small.uri.url)
              : '',
          });
        } catch {
          return null;
        }
      })
    );
  }
}
